import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import loadPortalConfig, { loadHeaderConfig } from './config';

async function init() {
  let portalConfig;
  const root = document.getElementById('devconsole-16-root');
  if (root) {
    portalConfig = await loadPortalConfig();
    ReactDOM.render(
      <App portalConfig={portalConfig} component="root" />,
      root,
    );
  } else {
    const globalHeader = document.getElementById('global-header');
    if (globalHeader) {
      if (!portalConfig) {
        portalConfig = await loadHeaderConfig();
      }
      ReactDOM.render(
        <App portalConfig={portalConfig} component="header" />,
        globalHeader,
      );
      const footerElement = document.getElementById('phoenix-footer');
      if (footerElement) {
        ReactDOM.render(
          <App portalConfig={portalConfig} component="footer" />,
          footerElement,
        );
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', () =>
  init(),
);



// WEBPACK FOOTER //
// ./src/index.js